import type {Directive} from "vue";
import {isEmpty} from "lodash-es";

const NfPostCode: Directive<HTMLInputElement> = {
    mounted(el) {
        function formatZip(_postCode: HTMLInputElement) {
            if (!isEmpty(_postCode.pattern)) {
                const pattern = new RegExp(_postCode.pattern);
                if (!pattern.test(_postCode.value)) {
                    if (_postCode.value !== '') {
                        _postCode.value = '';
                        _postCode.dispatchEvent(new Event('input'));
                    }
                    return;
                }
            }
            //usuwamy znaki specjalne.
            let value = _postCode.value.replace(/\D/g, '');
            let formattedValue = value;
            if (value.length > 2) {
                if (value.length <= 5) {
                    formattedValue = value.slice(0, 2) + '-' + value.slice(2);
                } else {
                    formattedValue = value.slice(0, 2) + '-' + value.slice(2, 6);
                }
            }

            if (_postCode.value !== formattedValue) {
                _postCode.value = formattedValue;
                _postCode.dispatchEvent(new Event('input'));
            }
        }

        el.addEventListener('input', function() {
            formatZip(el);
        });
    }
}

export default NfPostCode;
